export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8762.de4e63c2.jpg";